import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import { Redirect } from "react-router-dom"

// Applicant Information Redux States
import {
  CONSOLE_RESPONSE_RESET_STATE,
  CONSOLE_RESET_STATE,
  CONSOLE_COMPANY_LIST,
  CONSOLE_SIGNUP_LIST,
  CONSOLE_COPY,
  CONSOLE_SHARE,
  CONSOLE_SMS,
  CONSOLE_INVITE_SHARE,
  CONSOLE_INVITE_SMS,
  CONSOLE_CONNECT,
} from "./actionTypes"

import {
  consoleResponseResetStateSuccessful,
  consoleResponseResetStateFailed,
  consoleResetStateSuccessful,
  consoleResetStateFailed,
  consoleCompanyListSuccessful,
  consoleCompanyListFailed,
  consoleCopySuccessful,
  consoleCopyFailed,
  consoleShareSuccessful,
  consoleShareFailed,
  consoleSmsSuccessful,
  consoleSmsFailed,
  consoleSignupListSuccessful,
  consoleSignupListFailed,
  consoleInviteShareSuccessful,
  consoleInviteShareFailed,
  consoleInviteSmsSuccessful,
  consoleInviteSmsFailed,
  consoleConnectSuccessful,
  consoleConnectFailed,
} from "./actions"

import {
  fnGetMerchantUrls,
  fnShareMerchantUrlEmail,
  fnShareMerchantUrlSms,
  fnGetSignups,
  fnInviteShareEmail,
  fnInviteShareSms,
  fnConnect,
} from "../../helpers/Console/consoleService"
import { toast } from "react-toastify"

/* Resets state */
function* consoleResponseResetState({ payload: { } }) {
  try {    
    yield put(consoleResponseResetStateSuccessful())
  } catch (error) {
    console.log({error})
    yield put(consoleResponseResetStateFailed(error.message))
  }
}

/* Resets state */
function* consoleResetState({ payload: { error, history } }) {
  if (error) {
    yield put(consoleResetStateFailed(error))
  } else {
    yield put(consoleResetStateSuccessful(history))
  }
}

function* consoleCompanyList() {
  try {    
    const response = yield call(fnGetMerchantUrls);
    yield put(consoleCompanyListSuccessful(response))
  } catch (error) {
    yield put(consoleCompanyListFailed(error.message))
  }
}

function* consoleCopyUrl({ payload: {data, navigator } }) {
  try { 
    navigator.clipboard.writeText(data.invite_url ? data.invite_url : data.url)
    yield put(consoleCopySuccessful(true))
    toast.success("Link has been copied to clipboard", { autoClose: 2000 })
    console.log("Link has been copied to clipboard second time")
  } catch (error) {
    yield put(consoleCopyFailed(error.message))
    toast.error(error.message, { autoClose: 2000 })
  }
}

function* consoleShareUrl({ payload: { data } }) {
  try {    
    const response = yield call(fnShareMerchantUrlEmail, data);
    yield put(consoleShareSuccessful(response))
    toast.success("Email sent to emailed address provided", { autoClose: 2000 })
  } catch (error) {
    yield put(consoleShareFailed(error.message))
    toast.error(error.message, { autoClose: 2000 })
  }
}

function* consoleSmsUrl({ payload: { data } }) {
  try {    
    const response = yield call(fnShareMerchantUrlSms, data);
    yield put(consoleSmsSuccessful(response))
    toast.success("Url has been texted to the provide cell phone", { autoClose: 2000 })
  } catch (error) {
    yield put(consoleSmsFailed(error.message))
    toast.error(error.message, { autoClose: 2000 })
  }
}

function* consoleSignupList() {
  try {    
    const response = yield call(fnGetSignups);
    yield put(consoleSignupListSuccessful(response))
  } catch (error) {
    yield put(consoleSignupListFailed(error.message))
  }
}

function* consoleInviteShare({ payload: { data } }) {
  try {    
    const response = yield call(fnInviteShareEmail, data);
    yield put(consoleInviteShareSuccessful(response))
    toast.success("Email sent to emailed address provided", { autoClose: 2000 })
  } catch (error) {
    yield put(consoleInviteShareFailed(error.message))
    toast.error(error.message, { autoClose: 2000 })
  }
}

function* consoleInviteSms({ payload: { data } }) {
  try {    
    const response = yield call(fnInviteShareSms, data);
    yield put(consoleInviteSmsSuccessful(response))
    toast.success("Url has been texted to the provide cell phone", { autoClose: 2000 })
  } catch (error) {
    yield put(consoleInviteSmsFailed(error.message))
    toast.error(error.message, { autoClose: 2000 })
  }
}

function* consoleConnect({ payload: { data } }) {
  try {       
    const response = yield call(fnConnect, data);
    let {id, signups} = response
    yield put(consoleConnectSuccessful({id}))
    yield put(consoleSignupListSuccessful(signups))
    toast.success("Successfully added co-signer", { autoClose: 2000 })
  } catch (error) {
    yield put(consoleConnectFailed(error.message))
    toast.error(error.message, { autoClose: 2000 })
  }
}

function* consoleSaga() {
  yield takeEvery(CONSOLE_RESPONSE_RESET_STATE, consoleResponseResetState)
  yield takeEvery(CONSOLE_RESET_STATE, consoleResetState)
  yield takeEvery(CONSOLE_COMPANY_LIST, consoleCompanyList)
  yield takeEvery(CONSOLE_SHARE, consoleShareUrl)
  yield takeEvery(CONSOLE_SMS, consoleSmsUrl)
  yield takeEvery(CONSOLE_SIGNUP_LIST, consoleSignupList)
  yield takeEvery(CONSOLE_INVITE_SHARE, consoleInviteShare)
  yield takeEvery(CONSOLE_INVITE_SMS, consoleInviteSms)
  yield takeEvery(CONSOLE_CONNECT, consoleConnect)
  yield takeEvery(CONSOLE_COPY, consoleCopyUrl)  
}

export default consoleSaga
